import {
  MsalInterceptorConfiguration,
} from '@azure/msal-angular';
import {
  BrowserCacheLocation,
  IPublicClientApplication,
  InteractionType,
  PublicClientApplication
} from '@azure/msal-browser';
import { environment } from '@environment';
import { httpUrl } from '@shared/runtime-config';
import {
  buildAbsoluteUrl,
  resolveKnownAuthorities,
  resolveMsalAuthority,
  resolveMsalClientId,
  uniqueScopes
} from './msal.runtime';

/**
 * Build the map of API endpoints that MSAL's interceptor should attach a
 * bearer token to. The protected resources live behind APIM and currently
 * include the WhatsApp and public-common services. We protect the whole HTTP
 * service prefix instead of assuming an `/api` segment, so the interceptor
 * keeps working if a backend route shape changes to `/v1/...` or similar.
 * The required scopes come from `environment.msal.apiScopes`.
 */
function buildProtectedResourceMap(): Map<string, string[]> {
  const map = new Map<string, string[]>();
  const scopes = uniqueScopes(environment.msal?.apiScopes ?? []);
  if (scopes.length === 0) return map;
  if (!environment.apim?.baseUrl) return map;

  map.set(httpUrl('whatsapp'), scopes);
  map.set(httpUrl('common'), scopes);
  return map;
}

export function msalInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: resolveMsalClientId(),
      authority: resolveMsalAuthority(),
      knownAuthorities: resolveKnownAuthorities(),
      redirectUri: buildAbsoluteUrl(environment.msal?.redirectPath),
      postLogoutRedirectUri: buildAbsoluteUrl(environment.msal?.postLogoutRedirectPath),
      navigateToLoginRequestUrl: false
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage
    }
  });
}

export function msalInterceptorConfigFactory(): MsalInterceptorConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: buildProtectedResourceMap()
  };
}
